import { Box, IconQuoteOpen40, Text } from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { BusinessLine } from '../../types/definitions/vendor/graphql-schema.d';
import styles from './styles.module.scss';
export type PromoStylistCard = {
  id: 'mens-quote-promo-1' | 'womens-quote-promo-1' | '';
  name: 'mens_landing_page_promo' | 'womens_landing_page_promo';
  quoteText: string;
  quoteName: string;
  descriptor: string;
};
export const PROMO_STYLIST_CARD_CONTENT: Record<BusinessLine, PromoStylistCard> = {
  MENS: {
    id: 'mens-quote-promo-1',
    name: 'mens_landing_page_promo',
    quoteText: 'I just lost a bunch of weight and I am terrible at shopping so I thought I was open to try this to get me outside of my style comfort zone.',
    quoteName: 'Joseph',
    descriptor: 'Stitch Fix customer'
  },
  WOMENS: {
    id: 'womens-quote-promo-1',
    name: 'womens_landing_page_promo',
    quoteText: 'By collaborating to blend her unique taste, fit and body type, I helped Sara find the perfect jeans to flatter her petite frame!',
    quoteName: 'Christina',
    descriptor: 'stylist'
  },
  // Because we do not have an event name property for kids and shell stylist cards, our type check fails;
  // since we don't actually display promos for kids and shell clients, we can ignore these errors for now.
  // @ts-ignore:next-line
  KIDS: {
    id: '',
    name: '',
    quoteText: '',
    quoteName: '',
    descriptor: ''
  },
  // @ts-ignore:next-line
  SHELL: {
    id: '',
    name: '',
    quoteText: '',
    quoteName: '',
    descriptor: ''
  }
};
const PromoStylistCardSmall = ({
  id,
  name,
  quoteText,
  quoteName,
  descriptor
}: PromoStylistCard) => {
  const {
    ref,
    EventProvider
  } = useViewEvent({
    schema: 'view',
    name,
    content_id: id
  });
  return <EventProvider>
      <Box className={styles.PromoStylistCardSmall} ref={ref}>
        <IconQuoteOpen40 className={styles.quotationMark} purpose="decorative" />

        <Text height="tall" family="italic" as="p" scale="3">
          {`“${quoteText}”`}
        </Text>

        <Text height="tall" family="regular" scale="3">
          —{' '}
          <Text height="tall" family="medium">
            {quoteName}
          </Text>
          , {descriptor}
        </Text>
      </Box>
    </EventProvider>;
};
export default PromoStylistCardSmall;